
import React from 'react'
import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from '../../lib/auth.context'
import { WrongPortalNotice } from '../wrong-portal-notice'

export function ProtectedRoute() {
  const { status, isBanned, bannedUntil, wrongPortal, wrongPortalRedirecting } = useAuth()
  const location = useLocation()

  // FF-3636: the portal-membership gate in auth.context has already signed this user out. Explain
  // before the unauthenticated branch drops them on a login screen with no reason for it.
  if (wrongPortal) {
    return <WrongPortalNotice membership={wrongPortal} redirecting={wrongPortalRedirecting} />
  }

  if (status === 'loading') {
    return <div data-testid="loading-spinner">Loading...</div>
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  if (status === 'mfa_required') {
    if (location.pathname !== '/auth/mfa-verify') {
      return <Navigate to="/auth/mfa-verify" state={{ from: location }} replace />
    }
  }

  if (isBanned && bannedUntil) {
    const BannedUserMessage = React.lazy(() => import('../admin/users/banned-user-message').then(m => ({ default: m.BannedUserMessage })))
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <BannedUserMessage bannedUntil={bannedUntil} />
      </React.Suspense>
    )
  }

  return <Outlet />
}
